import type { CartItem, DeliveryMethod } from "../../../utils/types";
import { getShippingPrice } from "../BusinessOrderCreationPage.helpers";
import { DeliveryMethodNotice } from "./DeliveryMethodNotice";

type OrderPreviewProps = {
  activeCartItems: CartItem[];
  deliveryMethod: DeliveryMethod;
  freeDeliveryThreshold: number;
  businessDeliveryPrice: number;
};

const OrderPreview = ({
  activeCartItems,
  deliveryMethod,
  freeDeliveryThreshold,
  businessDeliveryPrice,
}: OrderPreviewProps) => {
  let totalPrice = 0;

  const productListItems = activeCartItems.map((cartItem: CartItem) => {
    totalPrice += cartItem.totalPrice;
    return (
      <tr key={cartItem.productName}>
        <td className="td  capitalized" key={cartItem.productName}>
          {cartItem.productName}
        </td>
        <td className="td  capitalized">{cartItem.quantity}kg</td>
      </tr>
    );
  });
  const calculatedShippingPrice =
    deliveryMethod === "shipping"
      ? getShippingPrice(
          totalPrice,
          freeDeliveryThreshold,
          businessDeliveryPrice,
        )
      : 0;
  return (
    <>
      <p className="left">
        Are you sure you want to order the following products:
      </p>
      <table className="table mini-table">
        <thead>
          <tr>
            <th className="th">Product</th>
            <th className="th">Quantity</th>
          </tr>
        </thead>
        <tbody>{productListItems}</tbody>
        <tfoot>
          <tr>
            <td className="td td-left" colSpan={2}>
              Subtotal : {totalPrice} kr
            </td>
          </tr>
          <tr>
            <td className="td td-left" colSpan={2}>
              {deliveryMethod === "shipping" ? (
                <p>Delivery: {calculatedShippingPrice} kr</p>
              ) : (
                <p>Pickup: Free</p>
              )}
            </td>
          </tr>
          <tr>
            <td className="td td-left" colSpan={2}>
              <span className="bold">
                Total Price: {totalPrice + calculatedShippingPrice} kr
              </span>
            </td>
          </tr>
        </tfoot>
      </table>
      <div className="left">
        {<DeliveryMethodNotice deliveryMethod={deliveryMethod} />}
      </div>
    </>
  );
};

export default OrderPreview;
